import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import { Done } from '@material-ui/icons'
import GridContainer from '../../../components/grid/GridContainer'
import GridItem from '../../../components/grid/GridItem'
// import Card from "../../../components/Card/Card";
// import Info from '../../../components/typography/Info'
import Label from '../../../components/typography/Label'
import { container, title, infoColor } from '../../../assets/material-kit-react'
import * as Sentry from '@sentry/browser'
import { withLocalize, Translate } from 'react-localize-redux';

Sentry.init({
    dsn: "https://a2a837fdcc7047ee8369a55e2f144948@sentry.io/1337446"
   });

class Home extends Component {

    componentDidCatch(error, errorInfo) {

        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
              scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
          });
          
    }


    render(){
        const { classes }  = this.props
      //  console.log("home", this.props)
        return (
        <div className ={classes.sections}>
            
                <div className = {classes.container}>
                    
                    <GridContainer className = {classes.gridContainer}>

                        <GridItem xs={12} sm={12} md={4}>

                            <h3 className={classes.subtitle}>
                                <Translate id="home_title"/>
                            </h3>
                            <Label>
                                <Translate id="home_description"/>
                            </Label>

                        </GridItem>

                        <GridItem xs={12} sm={12} md={8}>
                            {/* https://s3-ap-southeast-1.amazonaws.com/cdn.yomastrategic.net/cityloft/clus/sh_home_small.png */}
                            {/* https://s3-ap-southeast-1.amazonaws.com/cdn.yomastrategic.net/cityloft/clus/cl-home.jpg */}
                            {/* https://s3-ap-southeast-1.amazonaws.com/cdn.yomastrategic.net/cityloft/clus/room-imge-smaill.jpeg */}
                            <img className={classes.image} src={"https://s3-ap-southeast-1.amazonaws.com/cdn.yomastrategic.net/cityloft/clus/cl-home.jpg"} alt='livingroom'/>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>

                            <h3 className={classes.subtitle}>
                                <img className={classes.sun_icon} src={require('../../../images/sun_icon.svg')} alt='icon'/> <Translate id="home_amenities"/>
                            </h3>
                                
                            <Label>
                                <Done className={classes.iconColor}/> <Translate id="communication_center"/>
                            </Label>
                           
                            <Label> 
                                <Done className={classes.iconColor}/> <Translate id="swimming_pool"/>
                            </Label>

                            <Label> 
                                <Done className={classes.iconColor}/> <Translate id="gym"/>
                            </Label>

                            <Label> 
                                <Done className={classes.iconColor}/> <Translate id="green_spine"/>
                            </Label>

                            <Label>
                                <Done className={classes.iconColor}/> <Translate id="bus_terminal"/>
                            </Label>

                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>

                            <h3 className={classes.subtitle}>
                                <img className={classes.icon} src={require('../../../images/shopping_cart.svg')} alt='icon'/> <Translate id="commerical"/>
                            </h3>

                            <Label> 
                                <Done className={classes.iconColor}/>  
                                <Translate id="retail_stores"/>
                            </Label>

                            <Label> 
                                <Done className={classes.iconColor}/> <Translate id="market"/>
                            </Label>

                            <Label>
                                <Done className={classes.iconColor}/> <Translate id="plaza"/>
                            </Label>

                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>
                            <h3 className={classes.footertext}>
                                <Translate id="home_footer_description"/>
                            </h3>
                        </GridItem>

                    </GridContainer>

                   

                </div>
                <footer>
                        <img src={require('../../../images/CityLoftFrame.svg')} alt="Frame"/>
                 </footer>
           

            </div>
        )
    }

}


const styles = theme => ({
    sections: {
        flex: 1,
        minHeight: '100vh',
        background: "#FFFFFF",
      },
    container: {
        ...container,
        background: "#FFFFFF",
        
        paddingRight: '20px',
    },
    gridContainer: {
        paddingLeft: "12px"
    },
    title: {
        ...title,
        marginTop: "75px",
        fontSize: "1.5rem",
        fontWeight: "600",
        display: "inline-block",
        position: "relative",
        fontFamily: '"Poppins"',
        color: infoColor
    },
    subtitle: {
        marginTop:"75px",
        maxWidth: "500px",
        fontSize: "1.1em",
        fontFamily: '"Poppins"',
        fontWeight: "300",
        textAlign: "justify",
        color: infoColor
    },
    defaultFont: {
        fontFamily: '"Poppins"',
        fontSize: "13px",
        lineHeight: "1.5em",
        fontWeight: "300",
    },
    label: {
        fontFamily: '"Poppins"',
        fontSize: "12px",
        lineHeight: "1em",
        fontWeight: "300",
    },
    image: {
        width: '100%',
        height: '100%',
        border: "0",
        borderRadius: "4px",
    },
    icon: {
        width: '18px',  
        height: '18px',
    },
    sun_icon: {
        width: '16px',
        height: '16px',
    },
    iconColor: {
        color: infoColor,
        width: "15px",
        height: "15px",
        marginRight: "5px"
    },
    label_holder: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    footertext: {
        ...title,
        float:"right",
        marginTop: "75px",
        maxWidth: "400px",
        fontSize: "1.5rem",
        fontWeight: "600",
        display: "inline-block",
        position: "relative",
        fontFamily: '"Poppins"',
        textAlign: 'justify',
        color: infoColor
    },
})


Home.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withLocalize(withStyles(styles)(Home))
